// extracted by mini-css-extract-plugin
export var actionText = "_o7-4";
export var container = "_o7-0";
export var leftSection = "_o7-1";
export var rightSection = "_o7-2";
export var settingsButton = "_o7-6";
export var settingsIcon = "_o7-7";
export var shortcut = "_o7-5";
export var shortcutGroup = "_o7-3";